// extracted by mini-css-extract-plugin
module.exports = {"summaryTable":"checkout_summaryTable__3rlNG","total":"checkout_total__XVbuf","shippingMethod":"checkout_shippingMethod__5blC9"};